import PATHS from 'paths'

export const data = {
  title: 'Need a cremation now or thinking ahead? We can help',
  cards: [
    {
      image: 'illustrations/laptop-and-plan-blob-reverted',
      title: 'Buy a prepaid direct cremation plan',
      subtitle: 'All the benefits of our direct cremations, plus:',
      bulletedList: [
        'Protection from rising funeral costs',
        'Peace of mind for your loved ones',
        'A choice of ways to pay',
      ],
      ctaLink: {
        text: 'Buy a funeral plan',
        to: PATHS.CREMATION.FUNERAL_PLANS,
        variant: 'primary',
      },
    },
    {
      image: 'funerals/celebrations/how_to_arrange_a_funeral',
      title: 'Arrange a cremation for someone who’s died',
      subtitle: 'A direct cremation includes:',
      bulletedList: [
        'Support every step of the way',
        'A simple cremation you don’t attend',
        'Hand delivery or collection of the ashes',
      ],
      ctaLink: {
        text: 'Arrange a funeral now',
        to: PATHS.CREMATION.DIRECT,
        variant: 'primary',
      },
    },
  ],
}
